<script>
import { Line, mixins } from "vue-chartjs";
// import { Line, mixins } from "vue-chartjs";
// import zoom from "chartjs-plugin-zoom";
const { reactiveProp } = mixins;

export default {
  extends: Line,
  name: "chart",
  mixins: [reactiveProp],
  // props: {
  //   chartData: {
  //     type: Object,
  //     default: null
  //   },
  //   options: {
  //     type: Object,
  //     default: null
  //   }
  // },
  props: ["options"],
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  methods: {
    updateChart: function(data){
      this.renderChart(data, this.options);
    }
  },
};
</script>
